import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PlacementReviewStudent } from '../models/models.lib';
import { map, switchMap, tap } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { LoggerService } from '../shared/logger.service';
const { apiUrl } = environment;

export abstract class CasiMyPlacementReviewService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  public apiService = inject(ApiService);
  private loggerService = inject(LoggerService);

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<PlacementReviewStudent[]> {
    this.loading = true;

    // return this.apiService.getCsrf()
    //   .pipe(
    //     switchMap((token: any) => {
    //       this.loggerService.debug(`token: `, token);
    //       return this.http.get(encodeURI(`${apiUrl}/my/placement/reviews`),
    //         {
    //           withCredentials: true
    //         })
    //     })
    //   )
    return this.apiService.insertCsrf('/my/placement/reviews', 'GET')
      .pipe(
        map((response: any, i) => {
          return <PlacementReviewStudent[]>response;
        }),
        map(r => r.map(x => PlacementReviewStudent.create(x))),
        tap(() => {
          // this.apiService.getCsrfAsPromise();
          this.loading = false;
        })
      )
    // return this.http.get(encodeURI(`${apiUrl}/my/placement/reviews`),
    //   {
    //     withCredentials: true
    //   })
    //   .pipe(
    //     map((response: any, i) => {
    //       return <PlacementReviewStudent[]>response;
    //     }),
    //     map(r => r.map(x => PlacementReviewStudent.create(x))),
    //     tap(() => {
    //       this.apiService.getCsrfAsPromise();
    //       this.loading = false;
    //     })
    //   )
  }
}

@Injectable({
  providedIn: 'root'
})
export class MyPlacementReviewService extends CasiMyPlacementReviewService {
  constructor(
    http: HttpClient,
    // private apiService: ApiService
  ) {
    super(http)
  }

  get(email: string) {
    return this.apiService.postHttpCall(`/my/placement/reviews`, { email }, 'get');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`placement/review/student/${id}`, dataItem, 'update');
  }
}
